import React from "react"
import ContentLoader from "react-content-loader"

const ButtonSkeleton = (props) => {

    return (

        <ContentLoader
            speed={1}
            width={208}
            height={40}
            viewBox="0 0 208 40"
            backgroundColor="#F0F0F0"
            foregroundColor="#e8e8e8"
            {...props}
        >
            <circle cx="19" cy="21" r="12" />
            <rect x="40" y="17" rx="0" ry="0" width="100" height="8" />
            <rect x="190" y="17" rx="0" ry="0" width="13" height="8" />
        </ContentLoader>

    )
}

export default ButtonSkeleton
